import { cn } from '@forest/shared'
import { For, Show } from 'solid-js'
import type { Item } from '../store'

type Props = {
  items: Item[]
  currentIndex: number
}

export function Indicator(props: Props) {
  return (
    <div class="flex h-12 items-center justify-center space-x-3">
      <Show when={props.items.length > 1}>
        <For each={props.items}>
          {(_, index) => (
            <span
              class={cn(
                'text-white',
                index() !== props.currentIndex && 'opacity-70',
              )}
            >
              <Show when={props.currentIndex >= index()} fallback={<DotIcon />}>
                <CheckIcon />
              </Show>
            </span>
          )}
        </For>
      </Show>
    </div>
  )
}

function CheckIcon() {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6875 6.54922L5.225 10.0867L12.3125 3.01172"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

function DotIcon() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6.5498" r="6" fill="currentColor" />
    </svg>
  )
}
